export var Chain;
(function (Chain) {
    Chain["Optimism"] = "optimism";
    Chain["OptimismGoerli"] = "optimism-goerli";
    Chain["Arbitrum"] = "arbitrum";
    Chain["ArbitrumGoerli"] = "arbitrum-goerli";
})(Chain || (Chain = {}));
//# sourceMappingURL=chain.js.map